// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPlanYearLiteDto
 */
export interface IPlanYearLiteDto {
    /**
     * 
     * @type {number}
     * @memberof IPlanYearLiteDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IPlanYearLiteDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IPlanYearLiteDto
     */
    valid_from?: string;
    /**
     * 
     * @type {string}
     * @memberof IPlanYearLiteDto
     */
    valid_to?: string;
}

/**
 * Check if a given object implements the IPlanYearLiteDto interface.
 */
export function instanceOfIPlanYearLiteDto(value: object): value is IPlanYearLiteDto {
    return true;
}

export function IPlanYearLiteDtoFromJSON(json: any): IPlanYearLiteDto {
    return IPlanYearLiteDtoFromJSONTyped(json, false);
}

export function IPlanYearLiteDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPlanYearLiteDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'valid_from': json['valid_from'] == null ? undefined : json['valid_from'],
        'valid_to': json['valid_to'] == null ? undefined : json['valid_to'],
    };
}

export function IPlanYearLiteDtoToJSON(json: any): IPlanYearLiteDto {
    return IPlanYearLiteDtoToJSONTyped(json, false);
}

export function IPlanYearLiteDtoToJSONTyped(value?: IPlanYearLiteDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'valid_from': value['valid_from'],
        'valid_to': value['valid_to'],
    };
}

